import { MetadataStore } from 'breeze-client';

import { ApplicationUser } from './application-user';
import { Brand } from './brand';
import { Category } from './category';
import { Country } from './country';
import { Customer } from './customer';
import { Equipment } from './equipment';
import { EquipmentAttachment } from './equipment-attachment';
import { EquipmentAttachmentType } from './equipment-attachment-type';
import { EquipmentImage } from './equipment-image';
import { EquipmentModel } from './equipment-model';
import { EquipmentStatus } from './equipment-status';
import { Expense } from './expense';
import { ExpenseType } from './expense-type';
import { PurchaseTransaction } from './purchase-transaction';
import { SalesTransaction } from './sales-transaction';
import { Supplier } from './supplier';
import { TransactionType } from './transaction-type';
import { IdentityRole } from './identity-role';
import { IdentityRoleClaim } from './identity-role-claim';
import { IdentityUserClaim } from './identity-user-claim';
import { IdentityUserLogin } from './identity-user-login';
import { IdentityUserRole } from './identity-user-role';
import { IdentityUserToken } from './identity-user-token';

export class NorthwindRegistrationHelper {

    static register(metadataStore: MetadataStore) {
        metadataStore.registerEntityTypeCtor('ApplicationUser', ApplicationUser);
        metadataStore.registerEntityTypeCtor('Brand', Brand);
        metadataStore.registerEntityTypeCtor('Category', Category);
        metadataStore.registerEntityTypeCtor('Country', Country);
        metadataStore.registerEntityTypeCtor('Customer', Customer);
        metadataStore.registerEntityTypeCtor('Equipment', Equipment);
        metadataStore.registerEntityTypeCtor('EquipmentAttachment', EquipmentAttachment);
        metadataStore.registerEntityTypeCtor('EquipmentAttachmentType', EquipmentAttachmentType);
        metadataStore.registerEntityTypeCtor('EquipmentImage', EquipmentImage);
        metadataStore.registerEntityTypeCtor('EquipmentModel', EquipmentModel);
        metadataStore.registerEntityTypeCtor('EquipmentStatus', EquipmentStatus);
        metadataStore.registerEntityTypeCtor('Expense', Expense);
        metadataStore.registerEntityTypeCtor('ExpenseType', ExpenseType);
        metadataStore.registerEntityTypeCtor('PurchaseTransaction', PurchaseTransaction);
        metadataStore.registerEntityTypeCtor('SalesTransaction', SalesTransaction);
        metadataStore.registerEntityTypeCtor('Supplier', Supplier);
        metadataStore.registerEntityTypeCtor('TransactionType', TransactionType);
        metadataStore.registerEntityTypeCtor('IdentityRole', IdentityRole);
        metadataStore.registerEntityTypeCtor('IdentityRoleClaim', IdentityRoleClaim);
        metadataStore.registerEntityTypeCtor('IdentityUserClaim', IdentityUserClaim);
        metadataStore.registerEntityTypeCtor('IdentityUserLogin', IdentityUserLogin);
        metadataStore.registerEntityTypeCtor('IdentityUserRole', IdentityUserRole);
        metadataStore.registerEntityTypeCtor('IdentityUserToken', IdentityUserToken);
    }
}
